import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { FormControlLabel, Checkbox } from "@mui/material";
import MDBox from "theme/components/MDBox";

function CheckboxField({ formRef, draftIndex, displayName, fieldRef, options }) {
  const [isChecked, setIsChecked] = useState(false);
  // console.log(options);

  useEffect(() => {
    if (isChecked === null) {
      return;
    }

    const watchField = document.getElementById(`dff_${fieldRef}`);
    watchField.dispatchEvent(new Event("change"));
  }, [isChecked]);

  const [hasSavedValue, setHasSavedValue] = useState(false);
  const [draftValue, setDraftValue] = useState(null);

  useEffect(() => {
    if (!formRef) return;

    const saved = localStorage.getItem(`draft_${formRef}`);
    if (!saved) return;

    try {
      const parsed = JSON.parse(saved);
      const val = parsed?.[draftIndex].values?.[fieldRef];

      if (val !== undefined && val !== null && val !== "") {
        setIsChecked(draftValue === "yes" ? true : false);
      }
    } catch (e) {
      console.error("Draft parse error", e);
    }
  }, [formRef, fieldRef]);

  return (
    <MDBox>
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
          />
        }
        label={displayName}
      />
      <input
        type="hidden"
        id={`dff_${fieldRef}`}
        name={fieldRef}
        value={isChecked ? "yes" : "no"}
      />
    </MDBox>
  );
}

// Typechecking props of the Transaction
CheckboxField.propTypes = {
  formRef: PropTypes.string.isRequired,
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

CheckboxField.defaultProps = {
  options: null,
};

export default CheckboxField;
